import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, from, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  GENERATE_BILL_PDF,
  GET_ALL_VENDOR_INVOICES,
  GET_PURCHASE_ORDER_BY_VENDOR,
  LIST_ACCOUNTS,
  LIST_BILL_BY_ID,
  LIST_VENDORS,
} from '../graphql/vendor-invoice.queries';
import {
  APPROVE_OR_REJECT_BILL,
  CREATE_NEW_BILL,
  DELETE_BILL_BY_ID,
  UPDATE_BILL_BY_ID,
} from '../graphql/vendor-invoice.mutation';

@Injectable({ providedIn: 'root' })
export class VendorInvoiceService {
  constructor(private http: HttpClient, private apollo: Apollo) {}

  getAllVendorInvoices(input: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_ALL_VENDOR_INVOICES,
        variables: {
          input: input,
        },
        fetchPolicy: 'no-cache',
      })
      .valueChanges.pipe(
        map((response) => response.data?.findAllBillsWithPagination)
      );
  }

  removeBill(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: DELETE_BILL_BY_ID,
      variables: {
        id,
      },
    });
  }

  fetchVendors(search: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: LIST_VENDORS,
        variables: {
          search,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.vendors || []));
  }

  fetchAccounts(accountType: any, search: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: LIST_ACCOUNTS,
        variables: {
          accountType,
          search
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.findAccountsByType || [])
      );
  }

  createNewBill(createBillInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_NEW_BILL,
      variables: {
        createBillInput: createBillInput,
      },
    });
  }

  listBillById(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: LIST_BILL_BY_ID,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result?.data?.bill || []));
  }

   updateBillById(updateBillInput : any, id: any): Observable<any> {
      return this.apollo.use('accounts').mutate({
        mutation: UPDATE_BILL_BY_ID,
        variables: {
          updateBillInput : updateBillInput ,
          id: id
        },
      });
    }

     approveOrRejectBill(billId: any, isApproved: any): Observable<any> {
        return this.apollo.use('accounts').mutate({
          mutation: APPROVE_OR_REJECT_BILL,
          variables: {
            billId: billId,
            isApproved: isApproved
          },
        });
      }

      generateBillPdf(billId: any): Observable<any> {
          return this.apollo.use('accounts').mutate({
            mutation: GENERATE_BILL_PDF,
            variables: {
              billId: billId,
            },
          });
        }

        purchaseOrders(input: any): Observable<any> {
          return this.apollo
            .use('accounts')
            .watchQuery<any>({
              query: GET_PURCHASE_ORDER_BY_VENDOR,
              variables: {
                input: input,
              },
              fetchPolicy: 'no-cache',
            })
            .valueChanges.pipe(
              map((response) => response.data?.purchaseOrders)
            );
        }
}
